module.exports = __webpack_public_path__ + "img/002-mouse-cursor.0ddd9552.png";